/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const getFairStockTable = params => {
  return axios.get(`${base}/get_fairstock_` + params.fairid, params)
}



// WEBPACK FOOTER //
// ./src/views/fair-stock/fairStock.api.js